export default {
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    goPage(url) {
      this.$router.push('/webapp/' + url).catch(error => {
        if (error.name === 'NavigationDuplicated') {
          this.$EventBus.$emit('refresh')
        }
      })
    },
    goPageByName(name) {
      this.$router
        .push({
          name
        })
        .catch(error => {
          if (error.name === 'NavigationDuplicated') {
            this.$EventBus.$emit('refresh')
          }
        })
    },
    goPageWithParams(name, params) {
      this.$router
        .push({
          name,
          params
        })
        .catch(error => {
          if (error.name === 'NavigationDuplicated') {
            this.$EventBus.$emit('refresh', params)
          }
        })
    },
    goPageWithQuery(path, query) {
      this.$router
        .push({
          path,
          query
        })
        .catch(error => {
          if (error.name === 'NavigationDuplicated') {
            this.$EventBus.$emit('refresh', query)
          }
        })
    },
    goReplace(path) {
      this.$router.replace('/webapp/' + path)
    },
    isEmpty: value => {
      if (value === null) return true
      if (value === 'undefined') return true
      if (typeof value === 'undefined') return true
      if (typeof value === 'string' && value === '') return true
      if (Array.isArray(value) && value.length < 1) return true
      if (
        typeof value === 'object' &&
        value.constructor.name === 'Object' &&
        Object.keys(value).length < 1 &&
        Object.getOwnPropertyNames(value) < 1
      ) {
        return true
      }
      if (
        typeof value === 'object' &&
        value.constructor.name === 'String' &&
        Object.keys(value).length < 1
      ) {
        return true
      } // new String()

      return false
    },
    resizeImage(settings) {
      const file = settings.file
      const maxSize = settings.maxSize
      const reader = new FileReader()
      const image = new Image()

      return new Promise((resolve, reject) => {
        if (!file.type.match(/image.*/)) {
          reject(new Error('File is not image.'))
        }
        reader.onload = readerEvent => {
          image.onload = () => {
            resolve(this.resize(image, maxSize))
          }
          image.src = readerEvent.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    resize(image, maxSize) {
      const canvas = document.createElement('canvas')

      var width = image.width
      var height = image.height
      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width
          width = maxSize
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height
          height = maxSize
        }
      }
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(image, 0, 0, width, height)
      var dataUrl = canvas.toDataURL('image/jpeg')
      return this.dataURItoBlob(dataUrl)
    },
    dataURItoBlob(dataURI) {
      const bytes =
        dataURI.split(',')[0].indexOf('base64') >= 0
          ? atob(dataURI.split(',')[1])
          : unescape(dataURI.split(',')[1])
      const max = bytes.length
      const ia = new Uint8Array(max)
      for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i)
      return new Blob([ia], { type: 'image/jpeg' })
    },
    convertBlobToFile(blob, fileName) {
      blob.lastModifiedDate = new Date()
      blob.name = fileName
      return blob
    }
  }
}
